import IntegrationCallListResourceModel from '../../generated/types/model/resource/IntegrationCallListResourceModel';

export default class IntegrationCallListResourceViewModel extends IntegrationCallListResourceModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
